import { SessionStore } from "../uidispatcherapi/SessionStore";
import type { CommonCart } from "../model/CommonCartTypes";

function notNullOrUndefined(input: number | null | undefined) {
	return input !== undefined && input !== null;
}

const CUSTOMER_CART_SIZE_LIMIT = 100;
export function disallowAddingMoreItemsToCart(
	numberOfItemsInCart: number | null | undefined,
	numberToAdd = 1,
): boolean {
	return (
		!SessionStore.isEmployee() &&
		notNullOrUndefined(numberOfItemsInCart) &&
		notNullOrUndefined(numberToAdd) &&
		(numberOfItemsInCart as number) + numberToAdd > CUSTOMER_CART_SIZE_LIMIT
	);
}
export function getNumberOfItems(cart: CommonCart | null): number | null | undefined {
	return cart && cart.items && Object.keys(cart.items).length;
}
